import { z, isoZ } from 'my-zod'

export const vehicleUseSnapshotView = z.object({
  vehicleId: z.number().nullish(),
  snapshotDate: isoZ.instant().nullish(),
  mileage: z.number().nullish(),
  engineHours: z.number().nullish(),
  treadDepth: z.number().nullish(),
  images: z.any()
})

export type vehicleUseSnapshotView = z.infer<typeof vehicleUseSnapshotView>
